import React from 'react';
import NotificationsNoneIcon from '@mui/icons-material/NotificationsNone';
import LinearProgress from '@mui/material/LinearProgress';
import Box from '@mui/material/Box';
import { useSelector } from 'react-redux';

const NotificationBell = () => {
  const state = useSelector((state) => state.NotificationHistory);

  const unread = state.unread;
  const loading = state.imageLoad;

  return (
    <div
      style={{
        position: 'relative',
        display: 'inline-block',
      }}
    >
      {/* Bell Icon */}
      <NotificationsNoneIcon
        className={`menu-icon ${state.unread ? 'swing' : ''}`}
        sx={{
            transition: 'transform 0.3s ease-in-out',
            animation: state.unread
              ? 'swing-animation 0.5s ease-in-out infinite'
              : 'none',
            '@keyframes swing-animation': {
              '0%': { transform: 'rotate(0deg)' },
              '25%': { transform: 'rotate(15deg)' },
              '50%': { transform: 'rotate(-15deg)' },
              '75%': { transform: 'rotate(10deg)' },
              '100%': { transform: 'rotate(0deg)' },
            },
          }}
      />

      {/* Notification Dot */}
      {unread && (
        <Box
          sx={{
            position: 'absolute',
            top: 0,
            right: 0,
            width: '10px',
            height: '10px',
            backgroundColor: 'orange',
            borderRadius: '50%',
            boxShadow: '0 0 5px orange',
          }}
        />
      )}

      {/* Loading Bar & Text */}
      {loading && (
        <Box
          sx={{
            position: 'absolute',
            top: '2.5rem',
            left: '50%',
            transform: 'translateX(-50%)',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            zIndex: 1000,
          }}
        >
          {/* Arrow */}
          <Box
            sx={{
              width: 0,
              height: 0,
              borderLeft: '10px solid transparent',
              borderRight: '10px solid transparent',
              borderBottom: '10px solid #fff',
              marginBottom: '-1px',
            }}
          />

          {/* Loading Box */}
          <Box
            sx={{
              width: '200px',
              backgroundColor: '#fff',
              borderRadius: '8px',
              boxShadow: '0 4px 8px rgba(0, 0, 0, 0.2)',
              padding: '10px 20px',
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              border: '1px solid #ddd',
            }}
          >
            {/* Text */}
            <Box
              sx={{
                fontSize: '14px',
                color: '#555',
                marginBottom: '8px',
              }}
            >
              Processing Image...
            </Box>

            {/* Loading Bar */}
            <LinearProgress
              sx={{
                width: '100%',
                height: '6px',
                borderRadius: '4px',
                backgroundColor: 'cornflowerblue',
              }}
            />
          </Box>
        </Box>
      )}
    </div>
  );
};

export default NotificationBell;
